// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__HLpr6","approved":"Status_approved__2UGqd","rejected":"Status_rejected__14FMD","expired":"Status_expired__1bEXw","label":"Status_label__2kGKw"};